import React, { useState } from 'react';
import TripApp from './components/TripApp';
import NavelTripApp from './components/navel/NavelTripApp';
import TripSelector from './components/TripSelector';

// Import all trip configs
import budapestConfig from './trips/budapest.json';
import malagaConfig from './trips/malaga.json';
import bucharestConfig from './trips/bucharest.json';
import belgiumConfig from './trips/belgium.json';

// Trips that use the Navel aesthetic
const navelTripIds = new Set(['malaga-apr-2026', 'belgium-jun-2026']);

const allTrips = [
  belgiumConfig,
  malagaConfig,
  budapestConfig,
];

// Solo-access trips: accessible via ?solo#trip-id but not shown in trip selector
const soloTrips = [
  bucharestConfig,
];

const urlParams = new URLSearchParams(window.location.search);
const soloMode = urlParams.has('solo');

export default function App() {
  const [selectedTrip, setSelectedTrip] = useState(() => {
    const hash = window.location.hash.replace('#', '').toLowerCase();
    if (hash) {
      // Check solo trips first (accessible via direct link only)
      const soloTrip = soloTrips.find(t => t.id.toLowerCase() === hash);
      if (soloTrip) return soloTrip;
      // Then check regular trips
      const trip = allTrips.find(t => t.id.toLowerCase() === hash);
      if (trip) return trip;
    }
    if (allTrips.length === 1 && !soloMode) return allTrips[0];
    return null;
  });

  const handleSelectTrip = (trip) => {
    setSelectedTrip(trip);
    window.location.hash = trip.id;
    window.scrollTo({ top: 0 });
  };

  const handleBackToTrips = () => {
    setSelectedTrip(null);
    window.location.hash = '';
  };

  const TripComponent = selectedTrip && navelTripIds.has(selectedTrip.id) ? NavelTripApp : TripApp;

  // Solo mode: show only the requested trip, no back button
  if (soloMode && selectedTrip) {
    return <TripComponent tripConfig={selectedTrip} />;
  }

  // If only one trip, go straight to it
  if (allTrips.length === 1) {
    const OnlyComponent = navelTripIds.has(allTrips[0].id) ? NavelTripApp : TripApp;
    return <OnlyComponent tripConfig={allTrips[0]} />;
  }

  if (selectedTrip) {
    const isNavel = navelTripIds.has(selectedTrip.id);
    return (
      <div>
        <button
          onClick={handleBackToTrips}
          className={isNavel ? '' : 'fixed top-4 left-4 z-[60] bg-white bg-opacity-90 text-gray-700 px-3 py-2 shadow-md text-sm hover:bg-opacity-100 transition-all'}
          style={isNavel
            ? {
                position: 'fixed', top: 16, left: 16, zIndex: 110,
                width: 44, height: 44,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                background: 'rgba(22,36,34,0.5)', backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
                color: '#F2EDE5', border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: '50%', cursor: 'pointer', fontSize: '1.125rem',
                transition: 'background 0.2s ease'
              }
            : { borderRadius: '0px', fontFamily: 'Lato, sans-serif' }
          }
        >
          {isNavel ? '←' : '← All Trips'}
        </button>
        <TripComponent tripConfig={selectedTrip} />
      </div>
    );
  }

  return <TripSelector trips={allTrips} onSelectTrip={handleSelectTrip} />;
}
